import { environment } from '../../environments/environment';
const config = '';

const domain = window.location.href.split('#')[0].split('://')[0];
const host_domain = window.location.host;
export class Config {
  /**
 * Production Base Points
 */
  public static get PNP_BASE_API_URL(): String { return '/ilenspnp/api/v1.0/'; }
  public static get PNP_BASE_STREAM_URL(): String { return '/ilenspnp/stream/v1.0/'; }

  public static get BASE_POINT_API(): String { return '/cloud_2/'; }
  public static get BASE_POINT_API_METASTAX(): String { return '/cloud_2/'; }
  public static get BASE_POINT_API_PUBLIC_PORTAL(): String { return '/publicportal/'; }
  public static get BASE_POINT_API_DASHBOARD(): String { return '/dashboard/'; }
  public static get BASE_POINT_API_CHARTS(): String { return '/chart/'; }
  public static get BASE_POINT_API_VISUAL(): String { return '/visual/'; }
  public static get BASE_POINT_JSON(): String { return 'assets/static-data/'; }
  public static get COLOR_LIST(): any { return this.ColorCodesList; } // getting the color list for editor

  public static get BASE_POINT_API_OEE(): String { return '/oee/'; }
  public static get BASE_POINT_API_E_LOGBOOK(): String { return '/e_logbook/'; }
  public static get BASE_POINT_API_CSV_READER(): String { return '/csv_reader/'; }

  // tslint:disable:prefer-template

  public static API: any = {
    // PnP webapp services
    PNP_login: Config.PNP_BASE_API_URL + 'login',
    GET_TOKEN: Config.PNP_BASE_API_URL + 'get_token',
    PNP_fetch_map_data: Config.PNP_BASE_API_URL + 'markers_map',
    PNP_list_of_hierarchy: Config.PNP_BASE_API_URL + 'list_of_hierarchy',
    PNP_performance_prediction: Config.PNP_BASE_API_URL + 'performance_prediction',
    PNP_bubble_chart: Config.PNP_BASE_API_URL + 'bubble_chart',
    PNP_alert_center_list: Config.PNP_BASE_API_URL + 'alert_center_list',
    PNP_fetch_notications: Config.PNP_BASE_API_URL + 'get_notification_status',
    PNP_getThresholdListingTable: Config.PNP_BASE_API_URL + 'getThresholdListingTable',
    PNP_uploadPlantsConfiguration: Config.PNP_BASE_API_URL + 'save_plant_info',
    PNP_getUserManagementData: Config.PNP_BASE_API_URL + 'save_user_info',
    PNP_getPlantsListingTable: Config.PNP_BASE_API_URL + 'plant_info',
    PNP_reviewPlantsListingTable: Config.PNP_BASE_API_URL + 'review_plant_info',
    PNP_fetch_notifications: Config.PNP_BASE_API_URL + 'fetch_notifications',
    PNP_update_notifications: Config.PNP_BASE_API_URL + 'update_notifications',
    PNP_get_threshold_info: Config.PNP_BASE_API_URL + 'get_threshold_info',
    PNP_update_threshold_info: Config.PNP_BASE_API_URL + 'update_threshold_info',
    PNP_get_image: Config.PNP_BASE_API_URL + 'get_image?type=',
    PNP_get_profile_image: Config.PNP_BASE_API_URL + 'get_image',
    PNP_getCountryCodes: Config.BASE_POINT_JSON + 'country_codes.json',
    PNP_get_name: Config.PNP_BASE_API_URL + 'get_name',
    PNP_logout: Config.PNP_BASE_API_URL + 'logout',
    PNP_SAVE_LOGO_IMAGE: Config.PNP_BASE_API_URL + 'update_logo',
    PNP_GET_LOGO_IMAGE: Config.PNP_BASE_API_URL + 'get_logo',
    PNP_list_email_info: Config.PNP_BASE_API_URL + 'list_email_info',
    PNP_save_email_info: Config.PNP_BASE_API_URL + 'save_email_info',
    PNP_enable_email_info: Config.PNP_BASE_API_URL + 'enable_subject',
    PNP_delete_email_info: Config.PNP_BASE_API_URL + 'delete_email_info',
    PNP_configure_email_subject: Config.PNP_BASE_API_URL + 'configure_email_subject',
    PNP_get_configuration_menus: Config.PNP_BASE_API_URL + 'get_configuration_menus',
    PNP_fetchEmailSubject: Config.PNP_BASE_API_URL + 'fetchEmailSubject',
    PNP_reset_password: Config.PNP_BASE_API_URL + 'reset_password',
    PNP_getMSAccessConfData: Config.PNP_BASE_API_URL + 'list_ms_access',
    PNP_saveMSAccessConfData: Config.PNP_BASE_API_URL + 'save_ms_access',
    PNP_deleteMSAccessConfData: Config.PNP_BASE_API_URL + 'delete_ms_access',
    PNP_runMSAccessConfData: Config.PNP_BASE_API_URL + 'run_ms_access',
    PNP_listPlantMeta: Config.PNP_BASE_API_URL + 'list_plant_meta',
    PNP_manage_container: Config.PNP_BASE_API_URL + 'manage_container',
    PNP_fetch_container_logs: Config.PNP_BASE_STREAM_URL + 'agent/device/logs/stream',
    PNP_debug_device: Config.PNP_BASE_API_URL + 'debug_device',
    PNP_fqdn_device: Config.PNP_BASE_API_URL + 'save_endpoint',
    PNP_fetch_agent_logs: Config.PNP_BASE_API_URL + 'stream_logs',
    PNP_pipeline_approve: Config.PNP_BASE_API_URL + 'approve_pipeline',
    PNP_log_info: Config.PNP_BASE_API_URL + 'get_log_info',
    PNP_appConfiguration: Config.PNP_BASE_API_URL + 'save_deployment_name',
    PNP_E_mailConfiguration: Config.PNP_BASE_API_URL + 'save_email_details',
    PNP_SMSConfiguration: Config.PNP_BASE_API_URL + 'save_sms_details',
    PNP_NOTIFICATIONConfiguration: Config.PNP_BASE_API_URL + 'save_notification_details',
    PNP_SEND_NOTIFICATIONS: Config.PNP_BASE_API_URL + 'send_notifications',
    PNP_UPLOAD_LICENSE: Config.PNP_BASE_API_URL + 'upload_license_file',
    PNP_FETCH_LICENSE_DETAILS: Config.PNP_BASE_API_URL + 'fetch_license_details',
    PNP_FETCH_LICENSE_INFO: Config.PNP_BASE_API_URL + 'get_license_info',
    PNP_CHECK_SESSION_STATUS: Config.PNP_BASE_API_URL + 'check',


    // ================================== Sign Up =========================================
    // tslint:disable:prefer-template
    SIGN_UP :  Config.BASE_POINT_API_PUBLIC_PORTAL + 'public_portal/signup',
    LICENSE_INFO : Config.BASE_POINT_API + 'get_license_details',

    // SAVE_NEW_THING: Config.BASE_POINT_API + 'things/save_thing',
    SAVE_NEW_THING: Config.BASE_POINT_API + 'things/save_thing',

    FETCH_LIST_OF_PROPERTIES :  Config.BASE_POINT_API + 'things/list_property',
    
    FETCH_ALL_PROPERTIES_CATEGORIES : Config.BASE_POINT_API + 'things/list_property_category',
    FETCH_ALL_PROPERTIES_TYPES : Config.BASE_POINT_API + 'things/list_property_type',
    FETCH_ALL_PROPERTIES_GROUPS : Config.BASE_POINT_API + 'things/list_property_group',

    GENERATE_LEFT_SIDE_BAR: Config.BASE_POINT_API  + 'things/left_side_bar',
    /**   
     * Fetch General Property Types list ,  Wherever we are using searchable dropdowns  , 
     * ONLY searchable no pagaintion or sortings 
    */
    FETCH_GENERAL_PROPERTY_TYPES_LIST : Config.BASE_POINT_API + 'things/config/fetch_property_type_list',
    FETCH_GENERAL_PROPERTY_LIST : Config.BASE_POINT_API + 'things/config/fetch_property_list',
    FETCH_GENERAL_PROPERTY_GROUPS_LIST : '',
    FETCH_GENERAL_PROPERTY_CATEGORIES_LIST : '',
    // ================================ //

    CREATE_NEW_PROPERTY: Config.BASE_POINT_API + 'things/save_property',
    CREATE_NEW_PROP_CATEGORY: Config.BASE_POINT_API + 'things/save_property_category',
    CREATE_NEW_PROP_GROUP: Config.BASE_POINT_API + 'things/save_property_group',
    CREATE_NEW_PROP_TYPE: Config.BASE_POINT_API + 'things/save_property_type',

    DELETE_PROPERTY_TYPE: Config.BASE_POINT_API + 'things/delete_property_type',
    DELETE_PROPERTY_CATEGORY: Config.BASE_POINT_API + 'things/delete_property_category',
    DELETE_PROPERTY_GROUP: Config.BASE_POINT_API + 'things/delete_property_group',
    DELETE_PROPERTY: Config.BASE_POINT_API + 'things/delete_property',

    // -------- Details section -----------------//
    PROPERTY_CATEGORY_DETAILS : Config.BASE_POINT_API + 'things/fetch_property_category',
    PROPERTY_DETAILS : Config.BASE_POINT_API + 'things/fetch_property',
    PROPERTY_GROUP_DETAILS : Config.BASE_POINT_API + 'things/fetch_property_group',
    PROPERTY_TYPE_DETAILS : Config.BASE_POINT_API + 'things/fetch_property_type_details',

    CREATE_AND_LIST_ASSETS_FOLDER_THINGS_STUDIO: Config.BASE_POINT_API + 'hmi/create_check_folder',
    PROPERTY_LIST_IN_CATEGORY_OF_THING: Config.BASE_POINT_API + 'things/fetch_property_list_in_thing_category',
    // ------------ End ------------------------- //

    // ------------- Things  -----------//

    // ------------ End  ------------ //
    //=====================================================================================

    // ================================== Login Services ===================================    
    LOGIN: Config.BASE_POINT_API + 'user/login',
    SESSION_KEY: Config.BASE_POINT_API + 'logo/logo.png',
    GET_CAPTCHA : Config.BASE_POINT_API + 'get_captcha',
    VALIDATE_CAPTCHA: Config.BASE_POINT_API + 'verify_captcha',
    UPDATEPASSWORD: Config.BASE_POINT_API + 'user/update_password',
    FORGOT_PASSWORD: Config.BASE_POINT_API + 'user/forgot_password',
    RESET_PASSWORD: Config.BASE_POINT_API + 'user/reset_password',
    GET_PASS_SA: Config.BASE_POINT_API + 'user/system_password',
    SA_LOGIN: Config.BASE_POINT_API + 'user/system_login',

    // ================================== Dashboard Services ===================================
    SAVE_DASHBOARD: Config.BASE_POINT_API_DASHBOARD + 'dashboard/save',
    LIST_DASHBOARD: Config.BASE_POINT_API_DASHBOARD + 'dashboard/list',
    DELETE_DASHBOARD: Config.BASE_POINT_API_DASHBOARD + 'dashboard/delete',
    DASHBOARD_CHART_DATA: Config.BASE_POINT_API_DASHBOARD + 'chart/get',
    FETCH_FILTER_DATA: Config.BASE_POINT_API_DASHBOARD + 'dashboard/get_filters', // dashboard filter
    GET_WIDGET_ORDER: Config.BASE_POINT_API_DASHBOARD + 'dashboard/get_widget_order',
    SAVE_WIDGET_ORDER: Config.BASE_POINT_API_DASHBOARD + 'dashboard/save_widget_order',
    SAVE_HOME_DASHBOARD: Config.BASE_POINT_API + 'user/make_home_dashboard',
    EDIT_DASHBOARD: Config.BASE_POINT_API_DASHBOARD + 'widget/save_styles',
    // ================================== Widget Config ========================
    CHART_PREVIEW_DATA: Config.BASE_POINT_API_CHARTS + 'chart/preview',
    REPORT_GENERATE: Config.BASE_POINT_API_CHARTS + 'chart/report/generate',
    REPORT_DOWNLOAD: Config.BASE_POINT_API_CHARTS + 'chart/report/download',
    CHART_ANNOTATE: Config.BASE_POINT_API_CHARTS + 'chart/annotate',
    // CHART_PREVIEW_DATA: Config.BASE_POINT_API_CHARTS + 'chart/preview',
    CHART_PREVIEW_DATA_TOPICS: Config.BASE_POINT_API_DASHBOARD + 'dashboard/list_topic',
    CHART_GET_METADATA: Config.BASE_POINT_API_DASHBOARD + 'widget/get_meta_data',
    CHART_GET_TAG_DATA: Config.BASE_POINT_API_DASHBOARD + 'widget/get_filtered_meta_data',
    CHART_GET_UNIT_METADATA: Config.BASE_POINT_API_DASHBOARD + 'dashboard/unit_converter_meta_data',
    SAVE_WIDGET_DATA: Config.BASE_POINT_API_DASHBOARD + 'widget/save',
    GET_DASHBOARD_DATA: Config.BASE_POINT_API_DASHBOARD + 'widget/list',
    DELETE_WIDGET: Config.BASE_POINT_API_DASHBOARD + 'widget/delete',

    GET_SCHEDULE_INFO: Config.BASE_POINT_API_CHARTS + 'chart/report/get_schedule',
    SAVE_SCHEDULE_INFO: Config.BASE_POINT_API_CHARTS + 'chart/report/schedule',

    GET_DASHBOARD_SHARE_INFO: Config.BASE_POINT_API_DASHBOARD + 'dashboard/get_share',
    SAVE_DASHBOARD_SHARE_INFO: Config.BASE_POINT_API_DASHBOARD + 'dashboard/share',

    GET_USER_META: Config.BASE_POINT_API_DASHBOARD + 'dashboard/user/getmeta',
    DELETE_WIDGET_ANNOTATION: Config.BASE_POINT_API_DASHBOARD + '/chart/annotate/delete',

    // ======================================= Visualization endpoints ==================================
    VISUAL_SAVE_DASHBOARD: Config.BASE_POINT_API_VISUAL + 'dashboard/save',
    VISUAL_LIST_DASHBOARD: Config.BASE_POINT_API_VISUAL + 'dashboard/list',
    VISUAL_DELETE_DASHBOARD: Config.BASE_POINT_API_VISUAL + 'dashboard/delete',
    VISUAL_DASHBOARD_CHART_DATA: Config.BASE_POINT_API_VISUAL + 'chart/get',
    VISUAL_FETCH_FILTER_DATA: Config.BASE_POINT_API_VISUAL + 'dashboard/get_filters', // dashboard filter
    VISUAL_GET_WIDGET_ORDER: Config.BASE_POINT_API_VISUAL + 'dashboard/get_widget_order',
    VISUAL_SAVE_WIDGET_ORDER: Config.BASE_POINT_API_VISUAL + 'dashboard/save_widget_order',
    VISUAL_SAVE_HOME_DASHBOARD: Config.BASE_POINT_API + 'user/make_home_dashboard',
    // ------------------------------------- Visualization Widget Config ------------------------------
    VISUAL_PREVIEW_DATA: Config.BASE_POINT_API_VISUAL + 'chart/preview',
    VISUAL_REPORT_DOWNLOAD: 'downloadables/user_gen_reports',
    VISUAL_CHART_ANNOTATE: Config.BASE_POINT_API_VISUAL + 'chart/annotate',
    VISUAL_CHART_PREVIEW_DATA_TOPICS: Config.BASE_POINT_API_VISUAL + 'dashboard/list_topic',
    VISUAL_CHART_GET_METADATA: Config.BASE_POINT_API_VISUAL + 'widget/get_meta_data',
    VISUAL_CHART_GET_TAG_DATA: Config.BASE_POINT_API_VISUAL + 'widget/get_filtered_meta_data',
    VISUAL_CHART_GET_UNIT_METADATA: Config.BASE_POINT_API_VISUAL + 'dashboard/unit_converter_meta_data',
    VISUAL_SAVE_WIDGET_DATA: Config.BASE_POINT_API_VISUAL + 'widget/save',
    VISUAL_GET_DASHBOARD_DATA: Config.BASE_POINT_API_VISUAL + 'widget/list',
    VISUAL_DELETE_WIDGET: Config.BASE_POINT_API_VISUAL + 'widget/delete',
    VISUAL_GET_SCHEDULE_INFO: Config.BASE_POINT_API_VISUAL + 'chart/report/get_schedule',
    VISUAL_SAVE_SCHEDULE_INFO: Config.BASE_POINT_API_VISUAL + 'chart/report/schedule',
    VISUAL_GET_DASHBOARD_SHARE_INFO: Config.BASE_POINT_API_VISUAL + 'dashboard/get_share',
    VISUAL_SAVE_DASHBOARD_SHARE_INFO: Config.BASE_POINT_API_VISUAL + 'dashboard/share',
    VISUAL_GET_USER_META: Config.BASE_POINT_API_VISUAL + 'dashboard/user/getmeta',
    VISUAL_DELETE_WIDGET_ANNOTATION: Config.BASE_POINT_API_VISUAL + '/chart/annotate/delete',

    // Report Download
    VISUAL_REPORT_GENERATE: Config.BASE_POINT_API_VISUAL + 'report/generate',
    VISUAL_NOTIFICATION_LIST: Config.BASE_POINT_API_METASTAX + 'chart/notifications',

    // ==============================Reports EndPoints==================================
    GET_BASIC_FILTER_DATA: Config.BASE_POINT_API_CHARTS + 'report/metadata_fetch',
    GET_SITES_DEVICES: Config.BASE_POINT_API_CHARTS + 'report/device_metadata_fetch',
    GET_DEVICES_TAGS: Config.BASE_POINT_API_CHARTS + 'report/tag_metadata_fetch',
    SAVE_REPORT: Config.BASE_POINT_API_CHARTS + 'report/save',
    PREVIEW_REPORT: Config.BASE_POINT_API_CHARTS + 'report/preview',
    GET_REPORTS_LIST: Config.BASE_POINT_API_CHARTS + 'report/list',
    REPORT_WIDGET_SAVE: Config.BASE_POINT_API_CHARTS + 'report/widget/save',
    GET_REPORT_DATA: Config.BASE_POINT_API_CHARTS + 'report/widget/list',
    DELETE_REPORT: Config.BASE_POINT_API_CHARTS + 'report/delete',
    SHARE_REPORT: Config.BASE_POINT_API_CHARTS + 'report/share',
    GET_REPORT_SHARE_INFO: Config.BASE_POINT_API_DASHBOARD + 'report/get_share',


    // +++++++++++++++++++++++++++++ Logs Endpoints +++++++++++++++ 
    LOGS_LIST: Config.BASE_POINT_API_CHARTS + 'logbook/list',
    SAVE_LOG: Config.BASE_POINT_API_CHARTS + 'logbook/save',
    LOG_DELETE: Config.BASE_POINT_API_CHARTS + 'logbook/delete',
    LOG_PREVIEW: Config.BASE_POINT_API_CHARTS + 'logbook/preview',
    LOG_WIDGET_SAVE: Config.BASE_POINT_API_CHARTS + 'logbook/widget/save',
    LOG_WIDGET_LIST: Config.BASE_POINT_API_CHARTS + 'logbook/widget/list',
    SHARE_LOG: Config.BASE_POINT_API_CHARTS + 'logbook/share',
    GET_LOG_SHARE_INFO: Config.BASE_POINT_API_DASHBOARD + 'logbook/get_share',
    SAVE_LOGBOOK_ENTRY: Config.BASE_POINT_API_CHARTS + 'logbook/manual_entry',

    // ================================== Header Services ===================================
    INACTIVE_GATEWAY_AND_DEVICE_COUNT: Config.BASE_POINT_API + 'gateway_instance/inactive_count',
    // INACTIVE_GATEWAY_AND_DEVICE_COUNT: Config.BASE_POINT_API + '',

    // ++++++++++++++++++++++++++++++Configurations ENd Points+++++++++++++++++++++
    // sidebar
    CONFIGURATIONS_SIDEBAR: Config.BASE_POINT_API + 'left_side_bar/configurations',

    // ==================================Site Configuration========================
    INDUSTRY_GET_LIST: Config.BASE_POINT_API + config + 'industry/get_list',
    INDUSTRY_LOAD_TEMPLETE: Config.BASE_POINT_API + config + 'industry/get_body',
    INDUSTRY_SAVE: Config.BASE_POINT_API + config + 'industry/create',
    INDUSTRY_UPDATE: Config.BASE_POINT_API + config + 'industry/edit',
    INDUSTRY_DISABLE: Config.BASE_POINT_API + config + 'industry/disable',
    INDUSTRY_ENABLE: Config.BASE_POINT_API + config + 'industry/enable',
    FETCH_ZIP_CODE_DATA: Config.BASE_POINT_API + config + 'industry/get_pincode_details',

    // ==================================UserManagement Configuration========================
    // ------------------------------------User List------------------------------------------
    // USERLIST_GET_USER_LIST: Config.BASE_POINT_API + 'user/get_list',
    // USERLIST_GET_DROPDOWN: Config.BASE_POINT_API + 'user/get_body',
    // USERLIST_SAVE_USER: Config.BASE_POINT_API + 'user/create',
    // USERLIST_DELETE_USER: Config.BASE_POINT_API + 'user/delete',
    USERLIST_GET_DROPDOWN: Config.BASE_POINT_API + 'user/get_body',
    ADD_USER: Config.BASE_POINT_API + 'user/create',
    USER_TABLEDATA: Config.BASE_POINT_API + 'user/get',
    DELETE_USER: Config.BASE_POINT_API + 'user/delete',
    EDIT_USER: Config.BASE_POINT_API + 'user/edit',

    // ==================================UserRole========================

    ADD_USERROLE: Config.BASE_POINT_API + 'userrole/create',
    USERROLE_TABLEDATA: Config.BASE_POINT_API + 'userrole/get',
    DELETE_USERROLE : Config.BASE_POINT_API + 'userrole/delete',
    EDIT_USERROLE: Config.BASE_POINT_API + 'userrole/edit',

    // ==============================User access Level ====================
    GET_ACCESSLEVEL_LIST: Config.BASE_POINT_API + 'user_role/list',
    SAVE_ACCESS_LEVEL: Config.BASE_POINT_API + 'user_role/create',
    DELETE_ACCESS_LEVEL: Config.BASE_POINT_API + 'user_role/delete',

    // ------------------------------------Work Group------------------------------------------

    GET_WORKGROUP_LIST: Config.BASE_POINT_API + 'work_group/get',
    SAVE_WORKGROUP: Config.BASE_POINT_API + 'work_group/create',
    DELETE_WORKGROUP: Config.BASE_POINT_API + 'work_group/delete',

    // ================================== manual Entry Page ==================================
    MANUAL_ENTRY_GETMETADATA: Config.BASE_POINT_API + 'manual_entry/get_meta_data',
    MANUAL_ENTRY_MENU: Config.BASE_POINT_API + 'manual_entry/get_manual_entry_list',
    MANUAL_ENTRY_GET_ENTRY: Config.BASE_POINT_API + 'manual_entry/get_manual_entry',
    MANUAL_ENTRY_SAVE_CONFIG: Config.BASE_POINT_API + 'manual_entry/create',
    MANUAL_ENTRY_FETCH_TABLE: Config.BASE_POINT_API + 'manual_entry/fetch',
    MANUAL_ENTRY_BATCH_LIST: Config.BASE_POINT_API + 'manual_entry/get_meta_data/batch',
    MANUAL_ENTRY_SAVE : Config.BASE_POINT_API + 'manual_entry/save_entry',
    MANUAL_ENTRY_SAVE_METADATA: Config.BASE_POINT_API + 'manual_entry/save_matual_entry_metadata',

    /* ============================API for Rule Engine-------------------------- */
    GET_RULE_TABLE_AND_ROW_DATA: Config.BASE_POINT_API + 'rule_engine/get_list',
    SAVE_RULE_FORM_DATA: Config.BASE_POINT_API + 'rule_engine/create',
    DELETE_RULE_BY_ID: Config.BASE_POINT_API + 'rule_engine/delete',
    RULE_ENGINE_METADATA: Config.BASE_POINT_API + 'rule_engine/metadata',
    GET_MONACO_SUGGETION: Config.BASE_POINT_API + 'rule_engine/get/tag_data',
    GET_LOOKUP_TABLES_SUGGESSIONS: Config.BASE_POINT_API + 'rule_engine/lookup_meta_data',
    CHECK_IF_TAG_OVERRIDE: Config.BASE_POINT_API + 'rule_engine/',


    // ==================================Business Group============================
    // ----------------------------------Device Group------------------------------
    DEVICE_GROUP_LIST: Config.BASE_POINT_API + config + 'group/list/device_group',
    DEVICE_GROUP_FETCH: Config.BASE_POINT_API + config + 'group/get/device_group',
    DEVICE_GROUP_UPDATE: Config.BASE_POINT_API + config + 'group/create/device_group',
    // -----------------------------------Tag Group--------------------------------
    TAG_GROUP_LIST: Config.BASE_POINT_API + config + 'group/list/tag_group',
    TAG_GROUP_FETCH: Config.BASE_POINT_API + config + 'group/get/tag_group',
    TAG_GROUP_UPDATE: Config.BASE_POINT_API + config + 'create/tag_group',



    // ==================================Master Configuration======================

    // RFID Configuration
    // Master Table
    RFID_MASTER_TABLE: Config.BASE_POINT_API + 'tag/get_rfid',
    RFID_NEW_USER: Config.BASE_POINT_API + 'tag/create_rfid',
    RFID_DELETE_USER: Config.BASE_POINT_API + 'tag/delete_rfid',

    RFID_CURRENT_TABLE: Config.BASE_POINT_API + 'rfid/live_data',
    RFID_META_DATA: Config.BASE_POINT_API + 'rfid/get_metadata',
    RFID_HISTORICAL_TABLE: Config.BASE_POINT_API + 'rfid/get_history_data',

    // AI Models and AI Rule Engine
    // ANOMALY_MODEL_CREATE: Config.BASE_POINT_API + 'anomaly_model/create',
    // ANOMALY_MODEL_GET: Config.BASE_POINT_API + 'anomaly_model/get',
    // ANOMALY_MODEL_EDIT: Config.BASE_POINT_API + 'anomaly_model/edit',
    // ANOMALY_MODEL_DELETE: Config.BASE_POINT_API + 'anomaly_model/delete',
    // ANOMALY_RULE_CREATE: Config.BASE_POINT_API + 'anomaly_rule/create',
    // ANOMALY_RULE_GET: Config.BASE_POINT_API + 'anomaly_rule/get',
    // ANOMALY_RULE_EDIT: Config.BASE_POINT_API + 'anomaly_rule/edit',
    // ANOMALY_RULE_DELETE: Config.BASE_POINT_API + '/anomaly_rule/delete',

    /**
     * New End Points
     */
    AI_MODEL_CREATE: Config.BASE_POINT_API + 'ai/model/create',
    AI_MODEL_GET: Config.BASE_POINT_API_METASTAX + 'ai/list_model',
    AI_MODEL_DETAIL: Config.BASE_POINT_API_METASTAX + 'ai/model_detail',
    // AI_MODEL_GET: Config.BASE_POINT_API + 'ai/list_model',
    AI_MODEL_EDIT: Config.BASE_POINT_API + 'ai/model/get',
    AI_MODEL_DELETE: Config.BASE_POINT_API + 'ai/model/delete',

    AI_RULE_CREATE: Config.BASE_POINT_API + 'ai/rule/create',
    AI_RULE_GET: Config.BASE_POINT_API + 'ai/rule/list',
    AI_RULE_EDIT: Config.BASE_POINT_API + 'ai/rule/get',
    AI_RULE_DELETE: Config.BASE_POINT_API + 'ai/rule/delete',

    AI_RULE_ASSETS: Config.BASE_POINT_API + 'meta/fetch_all',
    AI_RULE_TAGS: Config.BASE_POINT_API + 'meta/fetch_tags',

    AI_RULE_CHART: Config.BASE_POINT_API + 'ai/chart/preview',

    // Gateway Type
    GATEWAY_TYPES_CREATE: Config.BASE_POINT_API + 'gateway_type/create',
    GATEWAY_TYPES_DELETE: Config.BASE_POINT_API + 'gateway_type/delete',
    GATEWAY_TYPES_GET: Config.BASE_POINT_API + 'gateway_type/get',

    // Gateway Model
    GATEWAY_GET_LIST: Config.BASE_POINT_API + 'gateway_model/list',
    GATEWAY_MODEL_PROTOCOL_LIST: Config.BASE_POINT_API + 'gateway_model/protocol_list/list',
    GATEWAY_MASTER_DFM: Config.BASE_POINT_API + 'gateway_model/get',
    GATEWAY_SAVE: Config.BASE_POINT_API + 'gateway_model/create',
    GATEWAY_MODEL_DISABLE: Config.BASE_POINT_API + 'gateway_model/disable',
    GATEWAY_MODEL_DELETE: Config.BASE_POINT_API + 'gateway_model/delete',

    // Gateway Instance
    GATEWAY_SILO: Config.BASE_POINT_API + 'gateway_instance/list',
    GATEWAY_INSTANCE_GET_GATEWAY_MODEL_LIST: Config.BASE_POINT_API + 'gateway_instance/gateway_model/list',
    GATEWAY_INSTANCE_PROTOCOL_LIST: Config.BASE_POINT_API + 'gateway_instance/protocol_list/list',
    GATEWAY_LOAD_TEMPLETE1: Config.BASE_POINT_API + 'gateway_instance/get',
    GATEWAY_CREATE: Config.BASE_POINT_API + 'gateway_instance/create',
    GATEWAY_LOAD_MODEL_INSTANCE_TEMPLETE: Config.BASE_POINT_API + 'gateway_instance/gateway_model/get',
    GATEWAY_DISABLE: Config.BASE_POINT_API + 'gateway_instance/disable',
    GATEWAY_DELETE: Config.BASE_POINT_API + 'gateway_instance/delete',
    GATEWAY_STATUS: Config.BASE_POINT_API + 'gateway_instance/status',

    // Device Model
    DEVICE_MODEL_GETLIST: Config.BASE_POINT_API + config + 'device_model/list',
    DEVICE_MODEL_PROTOCOL_LIST: Config.BASE_POINT_API + 'device_model/protocol_list/list',
    DEVICE_MODEL_LOAD_TEMPLETE: Config.BASE_POINT_API + config + 'device_model/get',
    DEVICE_MODEL_LOAD_SAVE: Config.BASE_POINT_API + config + 'device_model/create',
    DEVICE_MODEL_DISABLE: Config.BASE_POINT_API + config + 'device_model/disable',
    DEVICE_MODEL_DELETE: Config.BASE_POINT_API + config + 'device_model/delete',
    DEVICE_MODEL_UPLOAD_CSV: Config.BASE_POINT_API + config + 'csv/upload',


    // Device Instance
    DEVICE_INSTANCE_LIST: Config.BASE_POINT_API + 'device_instance/list',
    CHANNEL_DEVICE_MODEL_LIST: Config.BASE_POINT_API + 'device_instance/device_model/list',
    DEVICE_MODEL_LOAD_INSTANCE: Config.BASE_POINT_API + 'device_instance/get',
    DEVICE_LOAD_MODEL_INSTANCE_TEMPLETE: Config.BASE_POINT_API + 'device_instance/device_model/get',
    DEVICE_MODEL_LOAD_CREATE: Config.BASE_POINT_API + 'device_instance/create',
    DEVICE_DISABLE: Config.BASE_POINT_API + 'device_instance/disable',
    DEVICE_DELETE: Config.BASE_POINT_API + 'device_instance/delete',
    DEVICE_MIGRATION: Config.BASE_POINT_API + 'device_instance/device_migration',





    TAG_SAVE: Config.BASE_POINT_API + 'tag/create',
    TAG_GET: Config.BASE_POINT_API + 'tag/get',
    GET_TAGS_LIST: Config.BASE_POINT_API + 'get/tag_list',
    MASTER_UNIT_GET_ALL: Config.BASE_POINT_API + 'unit/get_all',
    TAG_DELETE: Config.BASE_POINT_API + 'tag/delete',
    ALARM_LIST_GET: Config.BASE_POINT_API + 'alarm_list/get',
    ALARM_CONFIGURATION_GET: Config.BASE_POINT_API + 'alarm_configuration/get',
    ALARM_CONFIGURATION_CREATE: Config.BASE_POINT_API + 'alarm_configuration/create',
    ALARM_CONFIGURATION_DELETE: Config.BASE_POINT_API + 'alarm_configuration/delete',
    ALARM_CONFIGURATION_GET_TAGS: Config.BASE_POINT_API + 'alarm_configuration/get_tags',
    ALARM_ENABLE_OR_DISABLE: Config.BASE_POINT_API + 'alarm/enable_or_disable',
    ALARM_CONFIGURATION_GET_TAGS_FOR_DEVICE: Config.BASE_POINT_API + 'alarm_configuration/get_write_tags',

    DEVICE_TYPES_GET: Config.BASE_POINT_API + 'device_type/get',
    DEVICE_TYPES_CREATE: Config.BASE_POINT_API + 'device_type/create',
    DEVICE_TYPES_DELETE: Config.BASE_POINT_API + 'device_type/delete',

    ALARM_PRIORITY_TYPE_CREATE: Config.BASE_POINT_API + 'alarm_priority_type/create',
    ALARM_PRIORITY_TYPE_DELETE: Config.BASE_POINT_API + 'alarm_priority_type/delete',
    ALARM_PRIORITY_TYPE_GET: Config.BASE_POINT_API + 'alarm_priority_type/get',
    MULTIPLICATION_FACTOR_CREATE: Config.BASE_POINT_API + 'multiplication_factor/create',
    MULTIPLICATION_FACTOR_DELETE: Config.BASE_POINT_API + 'multiplication_factor/delete',
    MULTIPLICATION_FACTOR_GET: Config.BASE_POINT_API + 'multiplication_factor/get',

    UNIT_GET: Config.BASE_POINT_API + 'unit/get',
    UNIT_SAVE: Config.BASE_POINT_API + 'unit/create',
    UNIT_DELETE: Config.BASE_POINT_API + 'unit/delete',
    UNIT_GET_LIST: Config.BASE_POINT_API + 'unit/get_by_group',
    THRESHOLD_GET: Config.BASE_POINT_API + 'static/threshold/get',
    THRESHOLD_SAVE: Config.BASE_POINT_API + 'static/threshold/create',
    THRESHOLD_DELETE: Config.BASE_POINT_API + 'static/threshold/delete',

    // ==================================Batch Entry========================

    SAVE_BATCH_ENTRY: Config.BASE_POINT_API + 'batch/create',
    GET_TAG_GROUPS_OR_BATCH_DETAILS: Config.BASE_POINT_API + 'batch/tag_group_details/get',
    GET_TAGS_IN_TAG_GROUP: Config.BASE_POINT_API + 'batch/tag_details/get',
    GET_BATCH_ENTRY: Config.BASE_POINT_API + 'batch/list',
    DELETE_BATCH_ENTRY: Config.BASE_POINT_API + 'batch/delete',

    // ==================================Lookup Configuration========================

    ADD_LOOKUP: Config.BASE_POINT_API + 'lookup/create',
    LOOKUP_TABLEDATA: Config.BASE_POINT_API + 'lookup/get',
    DELETE_LOOKUP: Config.BASE_POINT_API + 'lookup/delete',

    // ==================================Lookup Tables========================
    LOOKUPS_LIST: Config.BASE_POINT_API + 'lookup_table/menu',
    LOOKUPS_TABLE: Config.BASE_POINT_API + 'lookup_table/create',
    SUBMIT_LOOKUP: Config.BASE_POINT_API + 'lookup_table/add_data',

    // ==================================Email Gateway Configuration========================
    EMAIL_GATEWAY_TABLE: Config.BASE_POINT_API + 'email_gateway/list',
    SAVE_EMAIL_GATEWAY: Config.BASE_POINT_API + 'email_gateway/create',
    DELETE_EMAIL_GATEWAY: Config.BASE_POINT_API + 'email_gateway/delete',
    SEND_TEST_MAIL: Config.BASE_POINT_API + 'test_mail/response',
    EMAIL_DEFAULT_GATEWAY: Config.BASE_POINT_API + 'email_gateway/system_defaults',

    // ==================================SMS Gateway Configuration========================
    SMS_GATEWAY_TABLE: Config.BASE_POINT_API + 'sms_gateway/list',
    SAVE_SMS_GATEWAY: Config.BASE_POINT_API + 'sms_gateway/create',
    DELETE_SMS_GATEWAY: Config.BASE_POINT_API + 'sms_gateway/delete',
    SEND_TEST_SMS: Config.BASE_POINT_API + 'test_sms/response',
    SMS_DEFAULT_GATEWAY: Config.BASE_POINT_API + 'sms_gateway/system_defaults',

    // Time Slot
    TIMESLOT_SAVE: Config.BASE_POINT_API + 'timeslot/create',
    TIMESLOT_GET: Config.BASE_POINT_API + 'timeslot/get',
    FULLTREE_GET: Config.BASE_POINT_API + 'timeslot/get_tree',
    LATESTTIMESLOT_GET: Config.BASE_POINT_API + 'timeslot/get_latest',
    // Alarm Type
    ALARMTYPE_GET: Config.BASE_POINT_API + 'static/alarm_type/get',
    ALARMTYPE_SAVE: Config.BASE_POINT_API + 'static/alarm_type/create',
    ALARMTYPE_DELETE: Config.BASE_POINT_API + 'static/alarm_type/delete',
    // Function Code
    FUNCTION_CODE_GET: Config.BASE_POINT_API + 'static/modbus_function_code/get',
    FUNCTION_CODE_SAVE: Config.BASE_POINT_API + 'static/modbus_function_code/create',
    FUNCTION_CODE_DELETE: Config.BASE_POINT_API + 'static/modbus_function_code/delete',
    // Aggregation Type
    AGGREGATION_TYPE_GET: Config.BASE_POINT_API + 'static/aggregation_type/get',
    AGGREGATION_TYPE_SAVE: Config.BASE_POINT_API + 'static/aggregation_type/create',
    AGGREGATION_TYPE_DELETE: Config.BASE_POINT_API + 'static/aggregation_type/delete',
    // Data Type
    DATA_TYPE_GET: Config.BASE_POINT_API + 'static/data_type/get',
    DATA_TYPE_SAVE: Config.BASE_POINT_API + 'static/data_type/create',
    DATA_TYPE_DELETE: Config.BASE_POINT_API + 'static/data_type/delete',
    // Frequency List
    FREQUENCY_LIST_GET: Config.BASE_POINT_API + 'static/frequency_list/get',
    FREQUENCY_LIST_SAVE: Config.BASE_POINT_API + 'static/frequency_list/create',
    FREQUENCY_LIST_DELETE: Config.BASE_POINT_API + 'static/frequency_list/delete',
    // Protocol List
    PROTOCOL_LIST_GET: Config.BASE_POINT_API + 'protocol_list/get_list',
    PROTOCOL_LIST_SAVE: Config.BASE_POINT_API + 'protocol_list/create',
    PROTOCOL_LIST_DELETE: Config.BASE_POINT_API + 'protocol_list/delete',
    GET_PROTOCOL_DATA: Config.BASE_POINT_API + 'protocol_list/get',
    // Protocol Category
    PROTOCOL_CATEGORY_GET: Config.BASE_POINT_API + 'protocol_category/get',
    PROTOCOL_CATEGORY_SAVE: Config.BASE_POINT_API + 'protocol_category/create',
    PROTOCOL_CATEGORY_DELETE: Config.BASE_POINT_API + 'protocol_category/delete',
    // Alarm Notification type
    ALARM_NOTIFY_TYPE_GET: Config.BASE_POINT_API + 'static/alarm_notify_type/get',
    ALARM_NOTIFY_TYPE_SAVE: Config.BASE_POINT_API + 'static/alarm_notify_type/create',
    ALARM_NOTIFY_TYPE_DELETE: Config.BASE_POINT_API + 'static/alarm_notify_type/delete',
    // Time Slot Group
    TIME_SLOT_GROUP_GET: Config.BASE_POINT_API + 'static/time_slot_group/get',
    TIME_SLOT_GROUP_SAVE: Config.BASE_POINT_API + 'static/time_slot_group/create',
    TIME_SLOT_GROUP_DELETE: Config.BASE_POINT_API + 'static/time_slot_group/delete',
    // ==================================Unit Converter========================

    SAVE_UNIT_CONVERTER: Config.BASE_POINT_API + 'unit_converter/create',
    GET_UNIT_CONVERTER_OR_UNITS: Config.BASE_POINT_API + 'unit_converter/get_body',

    // ==================================Alarms & Events========================
    GET_ALARMS_EVENTS: Config.BASE_POINT_API + 'triggered_alarms/get',
    ACKNOWLEDGE_ALARMS_EVENTS: Config.BASE_POINT_API + 'triggered_alarms/acknowledge',
    GET_NOTES_OF_TRIGGERED_ALARM: Config.BASE_POINT_API + 'alarm_configuration/get_note',
    SAVE_NOTES_OF_TRIGGERED_ALARM: Config.BASE_POINT_API + 'alarm_configuration/save_note',
    GET_ALARM_FILTERS: Config.BASE_POINT_API + '',
    // ==================================SLD========================

    // SLD LEFT SIDE BAR
    // ============================================== HMi / Scada Services Start===============================
    // UPDATE_SLD_TREE: Config.BASE_POINT_API_LOCAL + '',
    CREATE_SLD: Config.BASE_POINT_API + 'hmi/create',
    UPDATE_SLD_NAME: Config.BASE_POINT_API + 'hmi/name_update',
    SLD_LEFTSIDEBAR: Config.BASE_POINT_API + 'hmi/left_side_bar',
    GET_SLD_DATA: Config.BASE_POINT_API + 'hmi/get_template',
    DELETE_SLD: Config.BASE_POINT_API + 'hmi/delete',
    CREATE_AND_LIST_ASSETS_FOLDER: Config.BASE_POINT_API + 'hmi/create_check_folder',
    GET_SLD_TAG_EXTENTION: Config.BASE_POINT_API + 'hmi/tags',
    UPLOAD_AND_GET_SVG_PATH: Config.BASE_POINT_API + 'hmi/svg_create', // Up to version 2.1
    UPLOAD_AND_GET_ASSET_DETAILS: Config.BASE_POINT_API + 'hmi/asset_create', // after 2.1 version
    UPLOAD_FINAL_SVG_WITH_CONFIG_DATA: Config.BASE_POINT_API + 'hmi/update_svg',
    MOVE_ASSETS_TO_ANOTHER_FOLDER: Config.BASE_POINT_API + 'hmi/move_assets',
    UPDATE_SLD: Config.BASE_POINT_API + 'hmi/update',
    DELETE_LIBRARY_ASSETS: Config.BASE_POINT_API + 'hmi/asset/delete',
    CREATE_SLD_POINT: Config.BASE_POINT_API + 'hmi/create',
    SCADA_HOST_URL: domain + '://' + host_domain + Config.BASE_POINT_API,
    WRITTER_TAGS: Config.BASE_POINT_API + 'hmi/get_topic_list',
    USER_WORKGROUP_LIST: Config.BASE_POINT_API + 'hmi/user_workgroup_list',
    CURRENT_SUER_DETAILS: Config.BASE_POINT_API + 'hmi/current_user_details',
    HIGH_AVAILIBITY: Config.BASE_POINT_API + 'hmi/high_availibity_topics',
    AUDIT_LOG_TRIGGER: Config.BASE_POINT_API + 'hmi/audit_scada',
    GET_USER_LIST_FOR_HMI_SHARING: Config.BASE_POINT_API + 'hmi/user_workgroup_list_for_hmi_share',
    GET_FILTERED_STES_FOR_SLD_CREATION: Config.BASE_POINT_API + 'hmi/site_hierarchy',
    MOVE_SLD_TO_ANOTHER_SITE: Config.BASE_POINT_API + 'hmi/move',

    // -------------------Unused Services in scada but important for Next phase-------------------------
    CREATE_NEW_SLD: Config.BASE_POINT_API + 'hmi/create',
    // ============================================== HMi / Scada Services Start===============================

    // =========================License Management============================
    SUBMIT_LICENSE_KEY: Config.BASE_POINT_API + 'license/create',
    // SUBMIT_LICENSE_KEY: '/app/' + 'license/create', 
    LICENSE_TABLE: Config.BASE_POINT_API + 'licence/get_licence_details',
    // LICENSE_TABLE: '/app/' + 'licence/get_licence_details',
    // LICENSE_TABLE: Config.BASE_POINT_API + 'license/create',
    // SUBMIT_LICENSE_KEY: Config.BASE_POINT_API + 'license_table/list',
    UPDATE_LICENSE: Config.BASE_POINT_API + 'user/update_licence',
    GET_UTILIZED_COUNT: Config.BASE_POINT_API + 'licence/verify_licence',
    // UPDATE_LICENSE: '/app/' + 'user/update_licence',
    // =============================Delete Services for All Pages================================
    DELETE_GATEWAY_MODEL: Config.BASE_POINT_API + 'gateway_model/delete',
    GET_AI_RULES_DROPDOWN: Config.BASE_POINT_API_DASHBOARD + 'widget/get_ai_rules',
    GET_AI_RULES_CHARTCONFIG_DATA: Config.BASE_POINT_API_DASHBOARD + 'widget/get_tags_for_ai_rules',
    // ============================= Services for Clinet Page================================
    GET_CLIENT_LIST: Config.BASE_POINT_API + 'client/list',
    GET_CLIENT_DATA: Config.BASE_POINT_API + 'client/view',
    DISABLE_CLIENT_ITEM: Config.BASE_POINT_API + 'client/remove',
    DELETE_CLIENT_ITEM: Config.BASE_POINT_API + 'client/remove',
    SAVE_CLIENT_ITEM: Config.BASE_POINT_API + 'client/save',
    GET_DFM_FOR_META_STORE: Config.BASE_POINT_API + 'meta_store',
    CLIENT_LICENSE_DETAILS: Config.BASE_POINT_API + 'client/license_details',
    GET_STANDALONE_LICENSE_DETAILS: Config.BASE_POINT_API + 'licence/get_licence_details_standalone',

    // ================================= Public Portel ========================================
    // ---------------------------------- Channel Config Device List--------------------------------------
    CLOUD_DEVICES_LIST: Config.BASE_POINT_API_PUBLIC_PORTAL + 'public_portal/device_configuration_list',
    CLOUD_DELETE_DEVICE: Config.BASE_POINT_API_PUBLIC_PORTAL + 'public_portal/device_delete',
    CLOUD_DOWNLOAD_DEVICE_CONFIG: Config.BASE_POINT_API_PUBLIC_PORTAL + 'public_portal/download_config',
    CLOUD_DEVICE_DETAILS: Config.BASE_POINT_API_PUBLIC_PORTAL + 'public_portal/device_details',
    CLOUD_DEVICE_LISTING_OF_KEYS: Config.BASE_POINT_API_PUBLIC_PORTAL + 'public_portal/list_keys',
    CLOUD_DEVICE_KEY_DETAILS: Config.BASE_POINT_API_PUBLIC_PORTAL + 'public_portal/key_details',
    CLOUD_DEVICE_SAVE_KEY: Config.BASE_POINT_API_PUBLIC_PORTAL + 'public_portal/save_key',
    CLOUD_DEVICE_DOWNLOAD_KEY_DETAILS: Config.BASE_POINT_API_PUBLIC_PORTAL + 'public_portal/download/',
    CLOUD_CREATE_GATEWAY_FOR_DEVICE : Config.BASE_POINT_API_PUBLIC_PORTAL + 'public_portal/save_gateway',
    CLOUD_DELETE_GATEWAY_FOR_DEVICE : Config.BASE_POINT_API_PUBLIC_PORTAL + 'public_portal/remove_gateway',
    CLOUD_CREATE_NEW_DEVICE : Config.BASE_POINT_API_PUBLIC_PORTAL + 'public_portal/save_device_config',
    CLOUD_GET_DOWNLODABLE_LINKS : Config.BASE_POINT_API_PUBLIC_PORTAL + 'public_portal/get_downloadable_link',
    CLOUD_DEVICE_CONFIG_DOWNLOAD: Config.BASE_POINT_API_PUBLIC_PORTAL + 'public_portal/download_conf/',
    CLOUD_DEVICE_TAG_CONFIGURATION: Config.BASE_POINT_API_PUBLIC_PORTAL + 'public_portal/update_tag_configuration',
    CLOUD_DOWNLOAD_USERGUIDE: Config.BASE_POINT_API_PUBLIC_PORTAL + 'public_portal/how_to_connect',

    // ============================== logout ===============================
    USER_LOGOUT: Config.BASE_POINT_API + 'user/logout',

    // ============================== Energy Summary ======================= 
    GET_MONACO_EDITOR_SUGGESTIONS: Config.BASE_POINT_API_DASHBOARD + 'energy_report/get_monaco_data',
    SAVE_SCHEDULE_ENERGYREPORT: Config.BASE_POINT_API_DASHBOARD + 'energy_report/schedule_report',
    GET_ENERGYREPORT_SCHEDULEINFO: Config.BASE_POINT_API_DASHBOARD + 'energy_report/get_schedule_report',

    // ============================== Device Configuration ===========================
    FILTER_VIRTUAL_DEVICES_WITH_SITES: Config.BASE_POINT_API+ 'device_instance/filter_by_site',

    // ================================= SPC Reports ==================================
    GET_SPC_META_DATA: Config.BASE_POINT_API_DASHBOARD+ 'widget/spc_report_get_metadata',

    // ========================== Pipeline Builder ===============================
    PIPELINE_JOBS_LISTING: Config.BASE_POINT_API+ 'flow_diagram/job_list', // Done

    CREATE_PIPELINE: Config.BASE_POINT_API+ 'flow_diagram/create', // Done
    DELETE_PIPELINE: Config.BASE_POINT_API+ 'flow_diagram/delete', // Done
    EDIT_PIPELINE: Config.BASE_POINT_API+ 'flow_diagram/get', // Done
    SAVE_PIPELINE: Config.BASE_POINT_API+ 'flow_diagram/create', // Done
    BUILD_PIPELINE: Config.BASE_POINT_API+ 'flow_diagram/build', // Done
    RENAME_PIPELINE: Config.BASE_POINT_API+ 'flow_diagram/create',
    LOAD_LIBRARY_META: Config.BASE_POINT_API+ 'flow_diagram/load_nodes', // Done
    LOAD_TOPICS_META_AFTER_BUILD: Config.BASE_POINT_API+ 'flow_diagram/get_pipeline_debug_topic_map',
    RUN_PIPELINE: Config.BASE_POINT_API+ 'flow_diagram/create', // Done
    LOAD_PIPELINES_TABLES: Config.BASE_POINT_API+ 'flow_diagram/list', // Done
    UPDATE_PIPELINE: Config.BASE_POINT_API+ 'flow_diagram/create', // Done
    CREATE_CUSTOME_NODE: Config.BASE_POINT_API+ 'flow_diagram/node/create', // Done
    FETCH_CUSTOM_NODE: Config.BASE_POINT_API+ 'flow_diagram/node/fetch', // Done
    DELETE_CUSTOM_NODE: Config.BASE_POINT_API+ 'flow_diagram/node/delete', // Done
    GET_CUSTOM_TEMPLTATE: Config.BASE_POINT_API+ 'flow_diagram/node/get_template', // Done
    SAVE_NODE_CONFIGURATION: Config.BASE_POINT_API+ 'flow_diagram/save_node_custom_config', // Done

    // -------------------------Pipeline Categories and components------------------------
    // categories
    GET_PIPELINE_CATEGORY_LIST: Config.BASE_POINT_API+ 'flow_diagram/category/get_category_list',
    GET_PIPELINE_CATEGORY_RECORD: Config.BASE_POINT_API+ 'flow_diagram/category/record',
    // components
    GET_PIPELINE_COMPONENTS_LIST: Config.BASE_POINT_API+ 'flow_diagram/component/get_components_list',
    MAKE_PIPELINE_COMPONENT_PUBLIC: Config.BASE_POINT_API+ 'flow_diagram/component/enable_public',

    // -------------------------Device Manager ------------------------------------
    DEVICE_MANGER_GROUP_LIST: Config.BASE_POINT_API+ 'device_manger/device_group/list',
    DEVICE_MANAGER_SAVE_DEVICE_GROUP: Config.BASE_POINT_API+ 'device_manager/save_device_group',
    DEVICE_MANAGER_GET_DEVICE_GROUP: Config.BASE_POINT_API+ 'device_manger/device_group/get', 
    DEVICE_MANAGER_GET_DEVICE_LIST: Config.BASE_POINT_API+ 'device_manager/device/list',
    DEVICE_MANAGER_GET_DEVICE: Config.PNP_BASE_API_URL + 'agent_monitor',
    DEVICE_MANAGER_SAVE_DEVICE:  Config.BASE_POINT_API+ 'device_manager/save_device',

    GET_MODELS_LIST: Config.BASE_POINT_API+ 'device_manager/model/catalog',
    DEPLOY_MODEL_TO_DEVICES: Config.BASE_POINT_API+ 'device_manager/save_model',
    DOWNLOAD_CONFIGURATIONS: Config.BASE_POINT_API+ 'device_manager/download_configurations',
    DOWNLOAD_CONFIGURATION_FILE: Config.BASE_POINT_API+ 'device_manager/download',
    FETCH_DEVICE_TYPES_FOR_DEVICE_CONFIG: Config.BASE_POINT_API+ 'device_manager/list_device_types',
    FETCH_DEVICE_PIPELINES: Config.PNP_BASE_API_URL + 'get_deployed_pipelines',
    FETCH_DEVICE_AUDIT_LOGS: Config.BASE_POINT_API+ 'device_manager/get_device_audit_log',

    //  =============================== Left Sidebar Order ======================
    UPDATE_LEFT_SIDEBAR_ORDER: Config.BASE_POINT_API+ 'user/save_order',

    // =============================== Profile ==================================
    LOAD_USER_PROFILE: Config.BASE_POINT_API + 'user/get_details',
    UPDATE_USER_PROFILE: Config.BASE_POINT_API + 'user/update_details',

  };

  // Json Base Points
  public static JSON: any = {

  };

  // Keys we need to use accross application. For logics and etc
  public static CONSTANTS: any = {
    SUCCESS: 'success',
    GAUGEMIN: 0,
    GAUGEMAX: 100000,
    MQTT: {
      ip: host_domain ,
      port: domain === 'http' ? '8083' : '8084',
      userName: environment['mqttUserName'],
      password: environment['mqttPassword'],
      useSSL: domain === 'http' ? false : true,
      rfidUserName: '',
      rfidPassword: '',
    },
    STORAGE: {
      USER_ID: 'pnp_user_id',
      USER_NAME: 'pnp_user_name',
      USER_ROLE: 'pnp_user_role',
      USER_TYPE: 'pnp_user_type',
      USER_DETAILS: 'pnp_userDetails',
      USERID: 'pnp_userId',
      USER_TOKEN: 'pnp_userToken'
    },
    OSM_TILES_URL: 'assets/images/osm/{z}/{x}/{y}.png',
    // OSM_TILES_URL: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    OSM_ATTRIBUTE: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  };

  public static debounceTime = 500;
  public static ColorCodesList: any = [];  // color list valiable

  // Alert messages to show in Application
  public static ALERT_MESSAGES: any = {
    LICENSE_ALERT_MESSAGE_1: 'You have exhausted the licensed count. Please update the license to add ',
    LICENSE_ALERT_MESSAGE_2: 'Do you want to cancel? Any changes made cannot be saved.',
    LICENSE_ALERT_MESSAGE_3: 'Are you sure do you want to delete this item?',
    LICENSE_ALERT_MESSAGE_4: 'Are you sure do you want to disable this item?',
    LICENSE_ALERT_MESSAGE_5: 'Are you sure do you want to enable this item?',
    LICENSE_ALERT_MESSAGE_6: 'Are you sure do you want to move this item to another container?',
    LICENSE_ALERT_MESSAGE_7: 'Item is disabled. Click on the bell icon to enable it and populate the data',
    DELETE_CONFIRMATION: 'Are you sure do you want to delete this',
  };

  // Version number
  public  static VERSION_NUMBER = 'v3.3';
  public  static alertCount = 12;
  /**
   * Method for generating random 1000 colors
   */
  public static setColorCodes() {
    if (this.ColorCodesList.length > 0) {
      return;
    }
    this.ColorCodesList = [];
    while (this.ColorCodesList.length <= 1000) {
      let color = this.getRandomColor();
      while (this.ColorCodesList.indexOf(color) > 0 || color.length !== 6) {
        color = this.getRandomColor();
      }
      this.ColorCodesList.push(color);
    }
  }

  public static getRandomColor() {
    return Math.floor(Math.random() * 16777215).toString(16);
  }
}
